import { useEffect } from 'react';
import { filterUndefinedOrNull } from 'common/utils/filter';
import { getSubdomainIndex } from 'common/utils/getQueryString';
import { hmacSha256Hex } from 'common/utils/crypto';
import { INTERCOM_SECRET_KEY } from 'config/envVariable';

function createGTM(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
}

export function useTagManager(initTrack) {
    useEffect(() => {
        if (initTrack) {
            const { custom_GTM = '' } = initTrack;
            if (custom_GTM) {
                createGTM(window, document, 'script', 'dataLayer', custom_GTM);
            }
        }
    }, [initTrack]);
}

export function pushDataLayer() {
    window.dataLayer = window.dataLayer || [];
    if (arguments.length > 1) {
        window.dataLayer.push(arguments);
    } else if (arguments[0]) {
        window.dataLayer.push(arguments[0]);
    }
}
// Ticket: https://app.clickup.com/t/8669e34cz
export function gtmPushClientTrackingInfo({
    formId,
    uniqueName,
    sponsorReportGA4MeasurementId,
    partnerReportGA4MeasurementId,
    customGA4MeasurementId,
    custom_FB_Pixel,
    custom_Line_TagId,
    custom_Adwords_Remarketing,
    sendPageView
}) {
    pushDataLayer({
        event: 'render',
        action: 'render_done',
        formId,
        reportGA4MeasurementId: sponsorReportGA4MeasurementId || partnerReportGA4MeasurementId,
        customGA4MeasurementId,
        custom_FB_Pixel,
        custom_Line_TagId,
        custom_Adwords_Remarketing,
        uniqueName,
        send_page_view: sendPageView,
        site: window.location.hostname
    });
}

export function gtmPushEditorTrackingInfo({
    guid,
    userId,
    name,
    email,
    uniqueName,
    sponsorId,
    sponsorName,
    plans
}) {
    // Ticket: https://feversocial.atlassian.net/browse/SUPPORT-3768
    const specialUniqueNameMapping = {
        feversocial: 'fever'
    };
    const processedUniqueName = specialUniqueNameMapping[uniqueName] ?? uniqueName;
    pushDataLayer({
        event: 'render',
        action: 'render_done',
        guid,
        userId,
        name,
        email,
        uniqueName: processedUniqueName,
        sponsorId,
        sponsorName,
        site: window.location.hostname,
        ...filterUndefinedOrNull(plans),
        hash: hmacSha256Hex(guid, INTERCOM_SECRET_KEY)
    });
}

export function gtmPushUserSubmit({ memberId, formId, sponsorId }) {
    pushDataLayer({
        event: 'fever_form_submit',
        formId,
        sponsorId,
        entryUuid: memberId
    });
}

export function gtmPushFormPublish({
    formId,
    sponsorId,
    sponsorName,
    uniqueName,
    site,
    formTitle
}) {
    // Ticket: https://feversocial.atlassian.net/browse/SUPPORT-3768
    const specialUniqueNameMapping = {
        feversocial: 'fever'
    };
    const processedUniqueName = specialUniqueNameMapping[uniqueName] ?? uniqueName;
    pushDataLayer({
        event: 'formPublish',
        formId,
        sponsorId,
        sponsorName,
        uniqueName: processedUniqueName,
        site,
        formTitle
    });
}

// https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc?locale=en_US
// 2. Format ClickID
export function generateFbcByFbclid(fbclid) {
    const version = 'fb';
    const subdomainIndex = getSubdomainIndex(window.location.href);
    const creationTime = Date.now();
    return subdomainIndex ? `${version}.${subdomainIndex}.${creationTime}.${fbclid}` : null;
}
